module.exports = __webpack_public_path__ + "static/media/shutterstock_1171819066-for-yembo.bcf25ab8.png";